import axios from 'axios'
import store from '@/store.js'
import router from '@/router.js'

const url = process.env.VUE_APP_GLOBAL_URL;

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response.status === 401) {
    store.commit('logout');
    router.push('/');
  }
  if (error.response && error.response.status === 403)
    router.push('/error/403');
});

const headers = () => {
  let headers = {
    headers: {
      'Content-Type': 'application/json'
    }
  }

  let token = store.getters['token']
  if (token) { Object.assign(headers.headers, { Authorization: token }) }

  return headers
}

const restPromise = (axiosPromise, params) => {
  return new Promise((resolve, reject) => {
    store.dispatch('waitingApiRequestsCount', true)
      .then(() => {
        axiosPromise
          .then(response => {
            if (response.data.status === 'SUCCESS') {
              if (params && params.resolveResponse) {
                resolve(response)
              } else {
                resolve(response.data.data)
              }
            } else if (response.data.suggestions) {
              resolve(response.data.suggestions); // обработка ответа ДаДаты
            } else {
              console.log(response)
              if (response.data.data)
                reject(response.data.data);
              else
                reject(response.data.message)
            }
          })
          .catch(reponse => reject(response.message))
          .finally(() => store.dispatch('waitingApiRequestsCount', false))
      })
  })
}

const doGet = (url, params) => {
  return restPromise(
    axios.get(url, headers()), params
  )
}

const doPut = (url, body, params) => {
  return restPromise(
    axios.put(url, body || {}, headers()), params
  )
}

const doPost = (url, body, params) => {
  return restPromise(
    axios.post(url, body || {}, headers()), params
  )
}

const doDelete = (url, params) => {
  return restPromise(
    axios.delete(url, headers()), params
  )
}

export default {
  auth (username, password) {
    username = encodeURIComponent(username)
    password = encodeURIComponent(password)

    return doPost(`${url}/auth?login=${username}&password=${password}`, null, { resolveResponse: true })
  },

  logout () {
    doPost(`${url}/logout`)
      .then(() => store.commit('logout'))
  },

  getClientByPhone (phone) {
    phone = encodeURIComponent(phone)
    return doGet(`${url}/clients?phone=${phone}`)
  },

  getOrderById (id) {
    return doGet(`${url}/orders/${id}`)
  },

  saveOrder (order) {
    return doPost(`${url}/orders`, order)
  },

  getAllOrders (beginTime, endTime) {
    return doGet(`${url}/orders?begin-time=${beginTime}&end-time=${endTime}`)
  },

  completeOrder (orderId) {
    return doPut(`${url}/orders/${orderId}/complete`)
  },

  getTruckingCategories () {
    return doGet(`${url}/directories/trucking-categories`)
  },

  getMoverCategories () {
    return doGet(`${url}/directories/mover-categories`)
  },

  getGarbageRemovalCategories () {
    return doGet(`${url}/directories/garbage-removal-categories`)
  },

  getPetrolCategories () {
    return doGet(`${url}/directories/petrol-categories`)
  },

  getFurnitureCategories () {
    return doGet(`${url}/directories/furniture-categories`)
  },

  getDowntimeCategories () {
    return doGet(`${url}/directories/downtime-categories`)
  },

  getAdditionalCategories () {
    return doGet(`${url}/directories/additional-categories`)
  },

  getGarbageDisposalDistricts () {
    return doGet(`${url}/directories/garbage-disposal-districts`)
  },

  getGarbageDisposalDistrictById (id) {
    return doGet(`${url}/directories/garbage-disposal-districts/${id}`)
  },

  createGarbageDisposalDistrict (district) {
    return doPost(`${url}/directories/garbage-disposal-districts`, district)
  },

  updateGarbageDisposalDistrict (id, district) {
    return doPut(`${url}/directories/garbage-disposal-districts/${id}`, district)
  },

  getTruckingCategoryById (id) {
    return doGet(`${url}/directories/trucking-categories/${id}`)
  },

  getMoverCategoryById (id) {
    return doGet(`${url}/directories/mover-categories/${id}`)
  },

  getGarbageRemovalCategoryById (id) {
    return doGet(`${url}/directories/garbage-removal-categories/${id}`)
  },

  getPetrolCategoryById (id) {
    return doGet(`${url}/directories/petrol-categories/${id}`)
  },

  getFurnitureCategoryById (id) {
    return doGet(`${url}/directories/furniture-categories/${id}`)
  },

  getDowntimeCategoryById (id) {
    return doGet(`${url}/directories/downtime-categories/${id}`)
  },

  getAdditionalCategoryById (id) {
    return doGet(`${url}/directories/additional-categories/${id}`)
  },

  createTruckingCategory (category) {
    return doPost(`${url}/directories/trucking-categories`, category)
  },

  createMoverCategory (category) {
    return doPost(`${url}/directories/mover-categories`, category)
  },

  createGarbageRemovalCategory (category) {
    return doPost(`${url}/directories/garbage-removal-categories`, category)
  },

  createPetrolCategory (category) {
    return doPost(`${url}/directories/petrol-categories`, category)
  },

  createFurnitureCategory (category) {
    return doPost(`${url}/directories/furniture-categories`, category)
  },

  createDowntimeCategory (category) {
    return doPost(`${url}/directories/downtime-categories`, category)
  },

  createAdditionalCategory (category) {
    return doPost(`${url}/directories/additional-categories`, category)
  },

  updateTruckingCategory (id, category) {
    return doPut(`${url}/directories/trucking-categories/${id}`, category)
  },

  updateMoverCategory (id, category) {
    return doPut(`${url}/directories/mover-categories/${id}`, category)
  },

  updateGarbageRemovalCategory (id, category) {
    return doPut(`${url}/directories/garbage-removal-categories/${id}`, category)
  },

  updatePetrolCategory (id, category) {
    return doPut(`${url}/directories/petrol-categories/${id}`, category)
  },

  updateFurnitureCategory (id, category) {
    return doPut(`${url}/directories/furniture-categories/${id}`, category)
  },

  updateDowntimeCategory (id, category) {
    return doPut(`${url}/directories/downtime-categories/${id}`, category)
  },

  updateAdditionalCategory (id, category) {
    return doPut(`${url}/directories/additional-categories/${id}`, category)
  },

  updateLeewayTime (id, leeway) {
    return doPut(`${url}/directories/leeway/${id}`, leeway)
  },

  getLeewayById (id) {
    return doGet(`${url}/directories/leeway/${id}`)
  },

  getLeeway () {
    return doGet(`${url}/directories/leeway`)
  },

  getWorkSettingByCode (code) {
    return doGet(`${url}/settings?code=${code}`)
  },

  getAllWorkSettings () {
    return doGet(`${url}/settings`)
  },

  saveWorkSettings (settings) {
    return doPut(`${url}/settings`, settings, { resolveResponse: true })
  },

  updateSetting (id, setting) {
    return doPut(`${url}/settings/${id}`, setting)
  },

  getDistricts () {
    return doGet(`${url}/directories/districts`)
  },

  getDistrictById (id) {
    return doGet(`${url}/directories/districts/${id}`)
  },

  createDistrict (district) {
    return doPost(`${url}/directories/districts`, district)
  },

  updateDistrict (id, district) {
    return doPut(`${url}/directories/districts/${id}`, district)
  },

  deleteDistrictById (id) {
    return doDelete(`${url}/directories/districts/${id}`)
  },

  getAvailableWorkers (serviceType, categoryId, serviceDateTime,
    serviceStartRegion, serviceEndRegion, serviceStartDistrict, serviceEndDistrict, cashPayment, servicePredictionHour) {
    return doGet(`${url}/workers/available-for-service?service-type=${serviceType}&category-id=${categoryId}&service-date-time=${serviceDateTime}&service-start-region=${encodeURIComponent(serviceStartRegion)}&service-end-region=${encodeURIComponent(serviceEndRegion)}&service-start-district=${encodeURIComponent(serviceStartDistrict)}&service-end-district=${encodeURIComponent(serviceEndDistrict)}&cash-payment=${cashPayment}&service-prediction-hour=${servicePredictionHour}`)
  },

  getAll () {
    return doGet(`${url}/workers/all`)
  },

  getRegions () {
    return doGet(`${url}/directories/regions`)
  },

  getCashboxOperationTypes () {
    return doGet(`${url}/cashbox/operation-type`)
  },

  getRegionById (id) {
    return doGet(`${url}/directories/regions/${id}`)
  },

  createRegion (region) {
    return doPost(`${url}/directories/regions`, region)
  },

  updateRegion (id, region) {
    return doPut(`${url}/directories/regions/${id}`, region)
  },

  deleteRegionById (id) {
    return doDelete(`${url}/directories/regions/${id}`)
  },

  getCashboxOperations (beginTime, endTime) {
    return doGet(`${url}/cashbox/operations?begin-time=${beginTime}&end-time=${endTime}`)
  },

  saveCashboxOperation (cashboxOperation) {
    return doPost(`${url}/cashbox/operation`, cashboxOperation)
  },

  editCashboxOperation (cashboxOperation) {
    return doPost(`${url}/cashbox/edit-operation`, cashboxOperation)
  },

  deleteCashboxOperation(id) {
    return doPost(`${url}/cashbox/delete-operation?id=${id}`)
  },

  getDataForNewWorker () {
    return doGet(`${url}/workers/new`)
  },
  getWorker (id) {
    return doGet(`${url}/workers/${id}`)
  },
  saveWorker (worker) {
    return doPost(`${url}/workers`, worker)
  },

  blockOrUnblockWorker (workerId, blocked) {
    return doPut(`${url}/workers/${workerId}`, { blocked: blocked }, { resolveResponse: true })
  },

  getAllWorkersSchedule (from, to) {
    return doGet(`${url}/workers/schedule/interval?begin-time=${from}&end-time=${to}`)
  },

  setWorkerSchedule (workerScheduleList) {
    return doPost(`${url}/workers/schedule`, workerScheduleList)
  },

  deleteWorkerSchedule (workerId, from, to, needPeriodTime) {
    return doDelete(`${url}/workers/schedule?worker-id=${workerId}&begin-time=${from}&end-time=${to}&need-period-time=${needPeriodTime}`,
      { resolveResponse: true })
  },

  getWorkersInShift (periodFrom, district) {
    return doGet(district ? `${url}/workers/shift?period-from=${periodFrom}&district=${district}` : `${url}/workers/shift?period-from=${periodFrom}`)
  },

  getWorkerTypes () {
    return doGet(`${url}/workers/types`)
}
,

getCompaniesFromDaData(query)
{
  let headers = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Token 370d952c377946c249ccc156a2b0c5bf0fa1772d'
    }
  };

  return restPromise(axios.post(
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party',
    {
      query: query,
      locations: [
        {
          kladr_id: 16
        }
      ],
      status: [
        'ACTIVE'
      ],
      count: 5
    },
    headers))
}
}
